import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { DocumentEntity } from 'src/app/core/class/DocumentEntity';
import { Message } from 'src/app/core/class/message';
import { UserWithDepartmentEntity } from 'src/app/core/class/UserEntity';
import { EnumContractUserRole } from 'src/app/core/constants/contract';
import { AutoUserService } from 'src/app/core/services/auto-user.service';
import { CommonService } from 'src/app/core/services/common.service';
import { CreateContractService } from 'src/app/core/services/create-contract.service';
import { ProcedureComponent } from 'src/app/shared/components/procedure/procedure.component';

@Component({
  selector: 'app-configuring-signin-flow',
  templateUrl: './configuring-signin-flow.component.html',
  styleUrls: ['./configuring-signin-flow.component.scss']
})
export class ConfiguringSigninFlowComponent implements OnInit, OnChanges {
  @Input() configFlowSignList: [];
  @Input() isDraft: boolean = false;
  @Input() selectedServiceType: any = {};
  isFormChanging = false;
  @Output() hasChange: EventEmitter<boolean> = new EventEmitter();
  @Output() configFlowSignListChange: EventEmitter<any[]> = new EventEmitter();
  RECORD_USER_PERFORM_SIGN: UserWithDepartmentEntity[] = [];
  subscriptions: Subscription = new Subscription();
  isUserSign: boolean;
  indexUserSign: number = -1;
  enterpriseIdInDocument = '';
  showTableMembers = true;
  document: DocumentEntity;
  nzCheckLoadingUserSign = false;
  inputUserValue: string;
  inputUserSignValue: string;
  filteredUserOptions = [];
  roleUser = EnumContractUserRole;
  nzCheckLoadingUser = false;
  approverNumber: any;
  isCheckApprover = false;
  constructor(
    private createContractService: CreateContractService,
    public autoUserService: AutoUserService,
    private toastr: ToastrService,
    private message: Message,
    private commonService: CommonService,
    private dialog: MatDialog,
  ) {
    this.approverNumber = localStorage.getItem('approverNumber');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.configFlowSignList && this.configFlowSignList.length) {
      let configFlowSignList = this.configFlowSignList.map((item: any) => {
        item['role'] = item.typeInSignFlow === 'VERIFY' ? '2' : '1';
        return item;
      })
      if (this.isDraft) {
        if (changes.selectedServiceType && changes.selectedServiceType.currentValue && changes.selectedServiceType.currentValue.internalFlowNotEdit == true) {
          this.recordsUserPerformSign('')
        } else {
          this.recordsUserPerformSign(configFlowSignList)
        }
      } else {
        if (changes.selectedServiceType && changes.selectedServiceType.currentValue 
          && changes.selectedServiceType.currentValue.internalFlowNotEdit == true
          && changes.selectedServiceType.previousValue && changes.selectedServiceType.previousValue.internalFlowNotEdit !== undefined
          ) {
          this.recordsUserPerformSign('')
        } else {
          this.recordsUserPerformSign(configFlowSignList)
        }
      }
     
    } else {
      if (changes.selectedServiceType && changes.selectedServiceType.currentValue && changes.selectedServiceType.currentValue.internalFlowNotEdit == true) {
        this.recordsUserPerformSign('')
      }
    }
  }

  ngOnInit() {
    this.subcribeData()
  }
  recordsUserPerformSign(res) {
    if (res && res.length) {
      this.RECORD_USER_PERFORM_SIGN = res.map((data) => ({
        ...data,
        signConfig: data.signConfig ? (typeof data.signConfig === 'string' ? this.setDataSignConfig(JSON.parse(data.signConfig)) : this.setDataSignConfig(data.signConfig)) : { resize: false, showImage: data.isSignDigitalCertificate ? true : (data.role == '1' ? true : false) }
      }));
      const checkUserSign = this.RECORD_USER_PERFORM_SIGN.filter(item => item.role === '1');
      if (checkUserSign.length > 0) {
        this.isUserSign = true;
        this.indexUserSign = this.RECORD_USER_PERFORM_SIGN.indexOf(checkUserSign[0])
      } else {
        this.isUserSign = false;
        this.indexUserSign = -1;
      }

      const checkApprover = this.RECORD_USER_PERFORM_SIGN.filter(item => item.role === '2');
      if (checkApprover.length === Number(this.approverNumber) || checkApprover.length > Number(this.approverNumber)) {
        this.isCheckApprover = true;
      } else {
        this.isCheckApprover = false;
      }
    } else {
      this.isCheckApprover = false;
      this.isUserSign = false;
      this.RECORD_USER_PERFORM_SIGN = []
    }
    this.configFlowSignListChange.emit(this.RECORD_USER_PERFORM_SIGN)
  }

  changeCheckbox() {
    this.configFlowSignListChange.emit(this.RECORD_USER_PERFORM_SIGN);
  }

  changeDisplaySignature() {
    this.configFlowSignListChange.emit(this.RECORD_USER_PERFORM_SIGN);
  }
  subcribeData() {
    this.subscriptions.add(
      this.createContractService.recordsUserPerformSign.asObservable().subscribe(res => {
        this.recordsUserPerformSign(res)
      })
    );
  }

  onChangeUserSignSearch(event): void {
    if (event.target.value.trim().length > 0) {
      this.nzCheckLoadingUserSign = true;
      this.autoUserService.fetchAutoDepartment(this.inputUserValue.trim())
        .then(result => {
          if (this.inputUserValue.trim().length > 0) {
            this.filteredUserOptions = result.sort(function (a, b) {
              return a.type.localeCompare(b.type)
            });
          } else {
            this.filteredUserOptions = [];
          }
        }).finally(() => {
          this.nzCheckLoadingUserSign = false;
        });
    } else {
      this.inputUserValue = '';
      this.filteredUserOptions = [];
    }
  }

  setFormChanging(changingStatus: boolean): void {
    this.isFormChanging = changingStatus;
    this.hasChange.emit(changingStatus);
  }

  checkExistedUserOrDepartment(userName: string, departmentName: string, userId: string, departmentId?: string, email?: string, role?: string) {
    let userExist = 0;
    let departmentExist = 0;
    let roleType = false;

    const existedList = this.RECORD_USER_PERFORM_SIGN.filter((e) => {
      if (departmentId && e.departmentId === departmentId) {
        departmentExist++;
        if (e.role === '1') {
          roleType = true;
        }
        return true;
      } else if (e.userId === userId) {
        userExist++;
        if (e.role === '1') {
          roleType = true;
        }
        return true;
      }
    });

    if (existedList.length > 0) {
      if (departmentExist > 0) {
        if (role === 'sign') {
          this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_department_apostrophe_duplicate_approve'), [departmentName]));
        } else {
          if (roleType) {
            this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_department_apostrophe_duplicate_sign'), [departmentName]));
          } else {
            this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_department_apostrophe_duplicate_approve'), [departmentName]));
          }
        }
      } else if (userExist > 0) {
        if (role === 'sign') {
          this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate_approve'), [userName + ' - ' + email]));
        } else {
          if (roleType) {
            this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate_sign'), [userName + ' - ' + email]));
          } else {
            this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate_approve'), [userName + ' - ' + email]));
          }
        }
      }
      return true;
    } else {
      return false;
    }
  }

  autocompleteUserSelected($event: any, model: any) {
    this.setFormChanging(true);
    if ($event.isUserInput) {
      if ((!model.representativeId || !model.representativeIsActive) && model.type === 'DEPARTMENT') {
        if (!model.representativeId) {
          this.toastr.error(this.message.getMessage('messages.no_representative'));
        } else {
          this.toastr.error(this.message.getMessage('messages.representative_inactive'));
        }
        return;
      }

      const userId = model.type === 'USER' ? model.id : model.representativeId;
      const userName = model.name;
      const departmentName = model.type === 'DEPARTMENT' ? model.departmentName : null;
      const departmentId = model.type === 'DEPARTMENT' ? model.departmentId : null;
      const email = model.email;

      if (!this.checkExistedUserOrDepartment(userName, departmentName, userId, departmentId, email, 'approve')) {
        // Re-set all old members to "APPROVE" role
        let RECORD_USER_PERFORM_SIGN = this.RECORD_USER_PERFORM_SIGN
        // .map((item, index) => {
        //   return {
        //     ...item,
        //     role: this.roleUser.APPROVE + ''
        //   };
        // });

        const USER_SIGN = RECORD_USER_PERFORM_SIGN.filter(item => item.role === '1')[0];
        if (USER_SIGN) {
          RECORD_USER_PERFORM_SIGN.splice(RECORD_USER_PERFORM_SIGN.indexOf(USER_SIGN), 1);
        }

        RECORD_USER_PERFORM_SIGN = [
          ...RECORD_USER_PERFORM_SIGN,
          {
            order: RECORD_USER_PERFORM_SIGN.filter((data) => data.role == '2').length ? RECORD_USER_PERFORM_SIGN.filter((data) => data.role == '2')[RECORD_USER_PERFORM_SIGN.filter((data) => data.role == '2').length - 1].order + 1 : 1,
            userId: model.type === 'USER' ? model.id : model.representativeId,
            enterpriseSignId: this.enterpriseIdInDocument,
            name: model.name,
            email: model.email,
            role: this.roleUser.APPROVE + '',
            phone: model.phone,
            isCreatedSide: true,
            departmentName: model.type === 'DEPARTMENT' ? model.departmentName : null,
            departmentId: model.type === 'DEPARTMENT' ? model.departmentId : null,
            isSignDigitalCertificate: model.isSignDigitalCertificate ? model.isSignDigitalCertificate : false,
            signConfig: model.signConfig ? this.setDataSignConfig(JSON.parse(model.signConfig)) : { resize: false, showImage: model.isSignDigitalCertificate ? true : (this.roleUser.APPROVE + '' == '1' ? true : false) },
            userPosition: model.userPosition
          }
        ];
        if (USER_SIGN) {
          USER_SIGN.order = RECORD_USER_PERFORM_SIGN.length + 1;
          RECORD_USER_PERFORM_SIGN.push(USER_SIGN);
        }
        this.recordsUserPerformSign(RECORD_USER_PERFORM_SIGN);
        this.createContractService.isDirty = true;
        this.inputUserValue = '';
        this.inputUserSignValue = '';
      }
    }
  }

  onClickDeleteElementRecordUser(userId: any): void {
    let RECORD_USER_PERFORM_SIGN = this.RECORD_USER_PERFORM_SIGN.filter(d => d.userId !== userId);
    // RECORD_USER_PERFORM_SIGN = RECORD_USER_PERFORM_SIGN.map((item, index) => (
    //   {
    //     ...item,
    //     order: index + 1
    //   }));

    // update role of last user to SIGN
    // if (RECORD_USER_PERFORM_SIGN.length > 0) {
    //   RECORD_USER_PERFORM_SIGN[RECORD_USER_PERFORM_SIGN.length - 1].role = this.roleUser.SIGN + '';
    // }
    this.recordsUserPerformSign(RECORD_USER_PERFORM_SIGN);
    this.setFormChanging(true);
    // this.validateErrorSetUser();
  }

  autocompleteUserSignSelected($event: any, model: any) {
    this.setFormChanging(true);
    if ($event.isUserInput) {
      if ((!model.representativeId || !model.representativeIsActive) && model.type === 'DEPARTMENT') {
        if (!model.representativeId) {
          this.toastr.error(this.message.getMessage('messages.no_representative'));
        } else {
          this.toastr.error(this.message.getMessage('messages.representative_inactive'));
        }
        return;
      }

      const userId = model.type === 'USER' ? model.id : model.representativeId;
      const userName = model.name;
      const departmentName = model.type === 'DEPARTMENT' ? model.departmentName : null;
      const departmentId = model.type === 'DEPARTMENT' ? model.departmentId : null;
      const email = model.email;

      if (!this.checkExistedUserOrDepartment(userName, departmentName, userId, departmentId, email, 'sign')) {
        // Re-set all old members to "APPROVE" role
        let RECORD_USER_PERFORM_SIGN = this.RECORD_USER_PERFORM_SIGN

        RECORD_USER_PERFORM_SIGN = [
          ...RECORD_USER_PERFORM_SIGN,
          {
            order: RECORD_USER_PERFORM_SIGN.length + 1,
            userId: model.type === 'USER' ? model.id : model.representativeId,
            enterpriseSignId: this.enterpriseIdInDocument,
            name: model.name,
            email: model.email,
            role: this.roleUser.SIGN + '',
            phone: model.phone,
            isCreatedSide: true,
            departmentName: model.type === 'DEPARTMENT' ? model.departmentName : null,
            departmentId: model.type === 'DEPARTMENT' ? model.departmentId : null,
            isSignDigitalCertificate: model.isSignDigitalCertificate ? model.isSignDigitalCertificate : false,
            signConfig: model.signConfig ? this.setDataSignConfig(JSON.parse(model.signConfig)) : { resize: false, showImage: model.isSignDigitalCertificate ? true : (this.roleUser.SIGN + '' == '1' ? true : false) },
            userPosition: model.userPosition
          }
        ];
        this.recordsUserPerformSign(RECORD_USER_PERFORM_SIGN);
        this.createContractService.isDirty = true;
        this.inputUserValue = '';
        this.inputUserSignValue = '';
        // this.isValidNoUserExist = false;
        // this.subscribeIsValidNoUserExist.next(false);
        // this.valueSelectedUserRole = (this.roleUser.APPROVE + '');
        // this.validateErrorSetUser();
        // console.log(this.RECORD_USER_PERFORM_SIGN);
      }
    }
  }

  onChangeUserSearch(event): void {
    if (event.target.value.trim().length > 0) {
      this.nzCheckLoadingUser = true;
      this.autoUserService.fetchAutoDepartment(this.inputUserSignValue.trim())
        .then(result => {
          if (this.inputUserSignValue.trim().length > 0) {
            this.filteredUserOptions = result.sort(function (a, b) {
              return a.type.localeCompare(b.type)
            });
          } else {
            this.filteredUserOptions = [];
          }
        }).finally(() => {
          this.nzCheckLoadingUser = false;
        });
    } else {
      this.inputUserSignValue = '';
      this.filteredUserOptions = [];
    }
  }

  openDialogProcedure(type: number, $event) {
    $event.stopPropagation();
    this.dialog.open(ProcedureComponent, {
      width: '70%',
      data: {
        type: type,
        internalFlowNotEdit: this.selectedServiceType ? this.selectedServiceType.internalFlowNotEdit : null
      }
    })
  }

  setColspan(maximumSpan: number): number {
    return maximumSpan;
  }

  onChangeOrderApproveSign() {
    this.setFormChanging(true);
    this.configFlowSignListChange.emit(this.RECORD_USER_PERFORM_SIGN);
  }

  setDataSignConfig(signConfig: any) {
    let newDataSignConfig = { ...signConfig };
    if(newDataSignConfig.resize === null || newDataSignConfig.resize === undefined) {
      newDataSignConfig = { ...newDataSignConfig, resize: false };
    }
    if(newDataSignConfig.showImage === null || newDataSignConfig.showImage === undefined) {
      newDataSignConfig = { ...newDataSignConfig, showImage: true };
    }
    return newDataSignConfig;
  }

}
